export default "__VITE_ASSET__v61dj0nk__"